import React from 'react';
import { ChevronDown } from 'lucide-react';

function SOPFlowchart({ steps }) {
  return (
    <div className="space-y-4">
      {steps.map((step, idx) => (
        <div key={idx} className="relative">
          {/* Step Card */}
          <div 
            data-testid={`sop-step-${idx}`}
            className="bg-white rounded-2xl p-5 shadow-md border-2 border-primary/20 hover:border-primary/40 transition-all"
          >
            <div className="flex gap-4">
              {/* Step Number Circle */}
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-lg">{idx + 1}</span>
                </div>
              </div>
              
              {/* Step Content */}
              <div className="flex-1 pt-2">
                <p className="text-gray-800 leading-relaxed">{step}</p>
              </div>
            </div>
          </div>

          {/* Arrow/Connector */}
          {idx < steps.length - 1 && (
            <div className="flex justify-center py-2">
              <div className="flex flex-col items-center">
                <div className="w-0.5 h-4 bg-gradient-to-b from-primary to-primary-light"></div>
                <ChevronDown className="h-6 w-6 text-primary" />
                <div className="w-0.5 h-4 bg-gradient-to-b from-primary-light to-primary"></div>
              </div>
            </div>
          )}

          {/* Final checkmark */}
          {idx === steps.length - 1 && (
            <div className="flex justify-center py-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-500 to-green-400 flex items-center justify-center shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default SOPFlowchart;
